var EAffiliateCouponType = /*#__PURE__*/ function(EAffiliateCouponType) {
    EAffiliateCouponType["Flat"] = "flat";
    EAffiliateCouponType["Percentage"] = "percentage";
    return EAffiliateCouponType;
}(EAffiliateCouponType || {});
export { EAffiliateCouponType };
